export enum ETripsEventName {
  CLAIMS_CAROUSEL_OPENED = 'Claims Carousel Opened',
  CLAIMS_CAROUSEL_VIEWED = 'Claims Carousel Viewed',
}

export interface IClaimsCarouselViewedEventInfo {
  slideNumber: number;
}
